import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import NotificationChannelHttpDetail from '../components/NotificationChannelHttpDetail';
import BreadCrumb from '../../shared/components/BreadCrumb';
import { Typography } from '@material-ui/core';
import NotificationChannelTypeId from "../models/NotificationChannelTypeId";

export interface INotificationRouteParams {
  channelType: string;
  notificationChannelId: string;
}

function GetNotificationChannelDetailComponent(channelTypeId: string) {
  switch (channelTypeId) {
    case NotificationChannelTypeId.HTTP.id.toLowerCase():
      return <NotificationChannelHttpDetail />;
    default:
      return null;
  }
}

const OrganizationNotificationChannelDetail = (
  props: RouteComponentProps<INotificationRouteParams>
) => {
  return (
    <div>
      <Typography
        color="textSecondary"
        gutterBottom={true}
        className="padding-bottom-8"
      >
        <BreadCrumb value="Organization" to="/organization/settings" />
        <BreadCrumb value="Notification Channels" to="/organization/notificationchannels" />
        {props.match.params.notificationChannelId && 'Edit'}
        {!props.match.params.notificationChannelId && 'New'}
      </Typography>
      {GetNotificationChannelDetailComponent(props.match.params.channelType)}
    </div>
  );
};

export default withRouter(OrganizationNotificationChannelDetail);



// WEBPACK FOOTER //
// ./src/modules/organization/pages/OrganizationNotificationChannelDetail.tsx